import React, { useEffect, useState } from 'react'
import { api } from '../../../../../utils'
import { SISTEMIPAGAMENTO } from '../../../../../utils/endpoint'
import Button from '../../../../atoms/Button/Button'
import FormField from '../../../../atoms/FormField/FormField'
import FormRadio from '../../../../atoms/FormRadio/FormRadio'
import FormInput from '../../../../atoms/FormInput/FormInput'
import LoadingSvg from '../../../../atoms/Loading/Loading'
import { trackingCheckout } from '../../../../../utils/gtm'
import useTrans from '../../../../../hooks/useTrans'
import { useRouter } from 'next/router'
import * as Sentry from '@sentry/browser'
import { useSelector } from 'react-redux'
import Tooltip from '../../../../atoms/Tooltip/Tooltip'
import { Info } from '../../../../atoms/NewIcons'

// ! Hardcoded
const opzioni_pagamento = [
  'Codificato Sipec',
  'Carta di credito',
  'Pagamento con Paypal',
  'Bonifico bancario anticipato',
]

// ! Inserire Questo Obj se si vuole testare IBAN
const test_iban = {
  attivo: true,
  codice: '932',
  descrizione:
    'Sarai reindirizzato alla pagina del nostro circuito di pagamento per inserire i tuoi dati della carta e confermare lâ€™ordine.',
  iban: '432493280943240003243423',
  id: 1,
  nome: 'Carta di credito',
}

const ModalitaPagamento = ({ props, step, setStep, carrello_main, Submit }) => {
  const [selectPagamento, setSelectPagamento] = useState(props.values.id_modalita_pagamento)
  const [opzioniPagamento, setOpzioniPagamento] = useState([])
  const [Loading, setLoading] = useState(false)
  const metodiPagamento = opzioniPagamento
  const router = useRouter()
  const t = useTrans()
  const { service_gift } = useSelector((state) => state?.servicegift)

  useEffect(() => {
    selectPagamento && props.setFieldValue('id_modalita_pagamento', selectPagamento)
  }, [selectPagamento])

  useEffect(() => {
    setLoading(true)
    api
      .get(SISTEMIPAGAMENTO, {
        params: {
          lang: router.locale,
        },
      })
      .then((res) => {
        setOpzioniPagamento(res?.data)
        props.setFieldValue('opzioni_pagamento', res?.data)
        setLoading(false)
      })
      .catch((err) => {
        setLoading(false)
        console.log(err)
        Sentry.captureException(err)
      })
  }, [])

  return Loading ? (
    <LoadingSvg />
  ) : (
    <div className="checkout__pagamento">
      {!service_gift && (
        <FormField
          status={props.errors.codice_sconto && 'error'}
          errorMessage={props.touched.codice_sconto && props.errors.codice_sconto}
          label={
            <>
              {t('Codice sconto')}
              <span className="checkout__pagamento__codice-sconto__info">
                <Tooltip
                  label={t('Inserisci il codice promozionale per applicare lo sconto')}
                  id="codice-sconto-tooltip"
                  size="sm"
                >
                  <Info />
                </Tooltip>
              </span>
            </>
          }
          className="checkout__formfield"
        >
          <FormInput
            onBlur={props.handleBlur('codice_sconto')}
            value={props.values.codice_sconto}
            placeholder={t('Inserisci codice')}
            onChange={(e) => props.setFieldValue('codice_sconto', e.target.value)}
          />
          <div className="checkout__pagamento__codice-sconto__alert">
            <p>
              {t('Attenzione: lo sconto verrà applicato dopo la conferma del metodo di pagamento')}
            </p>
          </div>
        </FormField>
      )}
      <FormField className="checkout__formfield">
        {opzioniPagamento.length > 0 &&
          opzioniPagamento.map((opzione) => (
            <div
              className={
                'checkout__option' +
                (selectPagamento === opzione.id ? ' checkout__option--selected' : '')
              }
              key={opzione.id}
            >
              <FormRadio
                label={opzione?.nome ? opzione?.nome : opzione?.descrizione}
                size="md"
                checked={selectPagamento === opzione.id}
                onClick={() => setSelectPagamento(opzione.id)}
              />
              {opzione?.iban ? (
                <p style={{ marginLeft: 30, fontSize: 16, marginTop: 10 }}>
                  <strong>IBAN:</strong> {opzione.iban}
                </p>
              ) : (
                opzione?.descrizione && (
                  <p style={{ marginLeft: 30, fontSize: 16, marginTop: 10 }}>
                    {opzione?.descrizione}
                  </p>
                )
              )}
            </div>
          ))}
      </FormField>
      {selectPagamento !== null && (
        <Button
          disabled={props.isValid ? false : true}
          label={t('Conferma pagamento')}
          variant="primary"
          size="medium"
          onClick={() => {
            setStep(step + 1)
            let payMethod = ''
            metodiPagamento.forEach((metodo) => {
              if (metodo.id == selectPagamento) payMethod = metodo.nome
            })
            trackingCheckout(carrello_main, 5, payMethod)
            Submit()
          }}
        />
      )}
    </div>
  )
}

export default ModalitaPagamento
